<!-- <div *ngIf="loading" class="d-flex align-items-center justify-content-center" style="min-height: 100dvh;">
    <span id="loader">
        <mat-spinner class="mx-auto" style="display:inline-block;" [diameter]="20" color="primary"
            mode="indeterminate"></mat-spinner> <strong class="ml-3">Loading...</strong>
    </span>
</div> -->

<span class="loading" *ngIf="loading">
    <mat-spinner [diameter]="20" mode="indeterminate"></mat-spinner> <span class="ml-3 text-white">Loading...</span>
</span>

<div class=" main-container cFade">
    <div class="d-flex inner-container flex-column">
        <div class="gap-1 d-flex flex-wrap align-items-center justify-content-between p-4 border-bottom">
            <div class="d-flex company-name align-items-center">
                <div class="logo bg-light align-items-center justify-content-center d-flex rounded">
                    <img *ngIf="company" [src]="company?.logo" onerror="this.style.display = 'none'" />
                </div>
                <div>
                    <div *ngIf="company" style="margin-bottom:-.5rem" class="text-dark">{{company?.name}}</div>
                    <small class="text-sm">CBT Portal</small>
                </div>
            </div>

            <div *ngIf="student" class="d-flex company-name align-items-center">
                <div class="logo bg-light align-items-center justify-content-center d-flex rounded">
                    <img [src]="student?.passport" onerror="this.src= 'assets/images/man.png'" />
                </div>
                <div>
                    <div style="margin-bottom:-.5rem;text-transform: capitalize;" class="text-dark">
                        {{student?.name.toLowerCase()}}</div>
                    <small class="text-sm">{{p_system == 'tert' ? student?.matric_no : student?.student_id}}</small>
                </div>

            </div>
        </div>
        <div class="d-flex flex-column h-100 w-100 main" *ngIf="examSections.length != 0 && examDetails">
            <div class="p-4 left">
                <p class="small-description text-sm">{{examDetails?.exam_title}} | <span
                        class="semibold">{{currentTime.date}}</span></p>
                <h3 class="section-head mt-1">Sections</h3>
                <div class="d-flex section-container">
                    <button type="button" (click)="sectionChanged(i)"
                        *ngFor="let examSection of examSections; let i = index"
                        class="py-2 px-3 text-sm rounded bg-white position-relative shadow-sm text-left {{i == activeSectionIndex ? 'active-section' : ''}}">{{examSection.section_title | uppercase}}
                        <span title="Total Questions"
                            class="position-absolute rounded-circle text-sm shadow-sm read-badge m-auto d-flex align-items-center justify-content-center">{{examSection.questions.length}}</span></button>
                </div>
            </div>
            <div class="px-4 pb-4 right my-2 border-left w-100">
                <div class="mb-3 d-none description-box justify-content-between align-items-center flex-wrap">
                    <div>
                        <h3 class="course-head"> Title: {{examDetails.title | uppercase}} </h3>
                        <span class="text-sm">{{examDetails?.exam_title}} | <span
                                class="semibold">{{currentTime.date}}</span></span>
                    </div>
                    <div class="big-time">
                        <p class="text-sm text-center" style="margin-bottom:-.4rem">Time Remaining</p>
                        <h3 class="tabular-nums" [style.color]="(totalTimeLeft < 300) ? 'red' : ''">{{displayTime}}</h3>
                    </div>
                </div>
                <div class="d-flex flex-column-reverse exam-area">
                    <div *ngFor="let question of activeSectionQuestions; let i = index"
                        class="{{i != activeQuestionIndex ? 'd-none' : ''}} w-100 form-container">
                        <form *ngIf="i == activeQuestionIndex" [formGroup]="CBTForm"
                            (ngSubmit)="saveExam(CBTForm.value, 'click')" class="d-flex flex-column w-100"
                            style="gap: 1rem; min-height: 100%;">
                            <!-- <div class="ml-5 w-50 text-danger">
                                Offense Meter: {{ getOffenceValue() }}% full.<br>
                                <div class="progress">
                                        <div class="progress-bar bg-danger" role="progressbar" [style.width]="getOffenceValue()+'%'" aria-valuemin="0" aria-valuemax="100">{{ getOffenceValue() }}%</div>
                                </div>
                                <span class="ml-auto text-danger mr-2"><small>Message: {{ malPracticeMessage }}</small></span>
                            </div> -->
                            <div *ngIf="camera_check == 1 || screen_check == 1">
                                <div class="flex justify-between mb-1">
                                    <div class="text-xs">
                                        Offence Meter: <span class="text-red-500 font-medium"
                                            *ngIf="malPracticeMessage">({{ malPracticeMessage }})</span>
                                    </div>
                                    <p>
                                        <span class="text-red-600 font-bold">{{this.malPracticeCount}} / {{ offence_limit }}</span>
                                    </p>
                                    <!-- <p>
                                        <span class="text-xs">{{ getOffenceValue() }}%</span>
                                    </p> -->
                                </div>
                                <div class="h-1 rounded-sm w-full bg-red-100 overflow-hidden">
                                    <div [style.width]="getOffenceValue()+'%'" class="bg-red-500 h-full"></div>
                                </div>
                                <!-- <mat-progress-bar class="m-0" color="accent" [value]=""
                                    aria-valuemin="0" aria-valuemax="100"></mat-progress-bar> -->
                            </div>

                            <div class="">
                                <span class="text-sm">{{this.examSections[activeSectionIndex]?.description}}</span>
                            </div>

                            <div class="{{question?.class}} question-box bg-white shadow-sm rounded p-4">
                                <div class="w-100 d-flex justify-content-between align-items-center ">
                                    <h3 class="semibold mb-1" style="font-size: 1.1rem;">Question {{i+1}}
                                    </h3>
                                    <span class="small-time tabular-nums"
                                        [style.color]="(totalTimeLeft < 300) ? 'red' : ''">{{displayTime}}</span>
                                </div>
                                <div class="question" [innerHTML]="question.question"></div>
                            </div>
                            <div class="{{question?.class}} options-box bg-white shadow-sm rounded p-4"
                                *ngIf="question.qtype != 'gap'">
                                <div *ngFor="let option of options; let oi= index">
                                    <input [value]="question[option.key]" [id]="'q'+question.question_id+oi"
                                        [checked]="question[option.key] == question.chosen_answer"
                                        (change)="sectionChanged(activeSectionIndex, activeQuestionIndex, question[option.key])"
                                        formControlName="q{{question.question_id}}" class="option-radio d-none"
                                        type="radio" #option>
                                    <!-- name="option" -->
                                    <button *ngIf="question[option.key]" [disabled]="!totalTimeLeft" type="button"
                                        (click)="optionSelected('q'+question.question_id+oi)"
                                        class="d-flex align-items-center mb-2" style="gap: 1rem;">
                                        <div
                                            class="border radio bg-light rounded-circle align-items-center justify-content-center d-flex">
                                            {{optionsLabel[oi]}}</div>
                                        <div class="text-sm" *ngIf="question.option_method == 'default'">
                                            {{question[option.key]}}
                                        </div>
                                        <div class="text-sm" *ngIf="question.option_method != 'default'"
                                            [innerHTML]="question[option.key]"></div>
                                    </button>
                                </div>
                            </div>

                            <input placeholder="Type your answere here..."
                                [value]="question.chosen_answer != null ? question.chosen_answer : ''"
                                formControlName="q{{question.question_id}}"
                                class="{{question?.class}} options-box bg-white shadow-sm rounded p-4"
                                *ngIf="question.qtype == 'gap'" />


                            <div class="d-flex flex-wrap pt-2 gap-1 justify-content-between">
                                <div class="d-flex flex-wrap gap-1">
                                    <button mat-raised-button *ngIf="displayPrevious" (click)="previousStep()"
                                        type="button"><mat-icon>navigate_before</mat-icon>
                                        Previous</button>
                                    <button *ngIf="displayNext" (click)="nextStep()" mat-raised-button type="button">
                                        <span class="flex items-center">
                                            <span>Next</span>
                                            <mat-icon class="ml-2">navigate_next</mat-icon>
                                        </span>
                                    </button>
                                </div>
                                <div>
                                    <button mat-raised-button color="primary" type="submit">Submit</button>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="w-full md:max-w-[17rem] flex flex-col gap-4">
                        <!-- *ngIf="exam_mode == 1 && camera_check == 1" -->
                        <div class="row {{exam_mode == 1 && camera_check == 1 ? '' : 'hidden'}}">
                            <div class="col-12">
                                <video #video autoplay muted width="300" height="100" class="rounded-lg"></video>
                            </div>
                        </div>

                        <div *ngIf="activeSectionQuestions.length > 0"
                            class="shadow-sm bg-white p-3 rounded-md question-numbers-container align-items-center justify-content-center d-flex flex-wrap">
                            <div
                                class="w-100 d-flex justify-content-between align-items-center border-bottom px-2 pb-3 my-1 ">
                                <span>Question {{activeQuestionIndex+1}}/{{activeSectionQuestions.length}}</span>
                                <span class="small-time tabular-nums"
                                    [style.color]="(totalTimeLeft < 300) ? 'red' : ''">{{displayTime}}</span>
                            </div>
                            <button matRipple (click)="sectionChanged(activeSectionIndex, i)" type="button"
                                class="{{i == activeQuestionIndex ?'current' : item?.answered ? 'answered' : item?.read ? 'read': 'unread'}} text-sm question-number rounded-circle d-flex align-items-center justify-content-center"
                                *ngFor="let item of activeSectionQuestions;let i = index">{{i+1}}</button>

                            <div class="w-100 border-top px-2 py-3 mt-1 d-flex flex-wrap" style="gap:.5rem">
                                <div class="d-flex gap-1">
                                    <div class="answered question-status-badge rounded"></div>
                                    <i class="text-xs text-muted"
                                        *ngIf="this.examSections[activeSectionIndex].answered == 0">No question answered
                                        yet</i>
                                    <span class="text-xs"
                                        *ngIf="this.examSections[activeSectionIndex].answered > 0">{{this.examSections[activeSectionIndex].answered}}
                                        question{{this.examSections[activeSectionIndex].answered == 1 ? '' : 's'}}
                                        answered</span>
                                </div>
                                <div class="d-flex gap-1">
                                    <div class="unread question-status-badge rounded"></div>
                                    <span class="text-xs">Unread questions</span>
                                </div>
                                <div class="d-flex gap-1">
                                    <div class="read question-status-badge rounded"></div>
                                    <span class="text-xs">Ignored Questions</span>
                                </div>
                                <div class="d-flex gap-1">
                                    <div class="current question-status-badge rounded"></div>
                                    <span class="text-xs">Current Question</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="gap-1 mt-auto p-4 d-flex justify-content-between align-items-center">
            <span class="text-sm text-uppercase" *ngIf="company">
                {{company?.subdomain+' CBT'}} | {{currentTime.year}}
            </span>
            <div class="powered-by">
                Powered By
                <img src="assets/images/edozzier-log.png" class="h-4 d-inline rm-drag" />
            </div>
        </div>
    </div>
</div>